import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Hero } from "../UI/Hero/Hero";
import AOS from "aos";
const Container = ({ content }) => {
  const toggle = useSelector((state) => state.Sidebar.toggle);


  const isAnyModalOpen = useSelector((state) => state.Modal.open);

  return (
    <div
      className={`duration-300 bg-secondary dark:bg-darkPrimary min-h-[calc(100vh-4rem)] ${
        toggle ? "max-md:pl-[0px] pl-[240px]" : ""
      }`}
    >
      <div className="relative z-0">
        <Hero />
      </div>
      <div

        className={`relative ${isAnyModalOpen ? "z-50" : "z-20"} px-1 -mt-14`}
      >
        {content}
      </div>
    </div>
  );
};

export default Container;
